"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.Column = function (_a) {
    var children = _a.children, align = _a.align;
    return (react_1.default.createElement(creator_ui_1.Flexbox, { flexDirection: "column", justifyContent: align }, children));
};
exports.Column.displayName = "Column";
